import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { Link,useNavigate} from 'react-router-dom';
import { getCartItems, setCartItems } from '../../util/Cart';

function Card({ product }) {
  const imageSrc = product.imageSrc || []; // Assuming product.imageSrc is the array of images
  const navigate = useNavigate();


  const [currentImage, setCurrentImage] = useState(imageSrc[0] || 'https://www.vallabhcomponent.com/assets/images/default.jpg');
  const [preloadedImages, setPreloadedImages] = useState([]);

  useEffect(() => {
    if (imageSrc.length >= 2) {
      const img1 = new Image();
      const img2 = new Image();
      img1.src = imageSrc[0];
      img2.src = imageSrc[1];
      setPreloadedImages([img1, img2]);
    } else if (imageSrc.length === 0) {
      const defaultImg = new Image();
      defaultImg.src = 'https://www.vallabhcomponent.com/assets/images/default.jpg';
      setPreloadedImages([defaultImg, defaultImg]);
    }
  }, [imageSrc]);

  const handleMouseEnter = () => {
    if (preloadedImages.length >= 2) {
      setCurrentImage(preloadedImages[1].src);
    }
  };

  const handleMouseLeave = () => {
    if (preloadedImages.length >= 1) {
      setCurrentImage(preloadedImages[0].src);
    }
  };


  const handleCheckout = () => {
    console.log("first")
    navigate(`/product/${product._id}`);
  };

  return (
    <div className='card'>
      <Link to={`/product/${product._id}`} className="card-link">
       <div className='card-image-container'>
       <img 
          src={currentImage} 
          alt={product.title} 
          className="card-img"
          onMouseEnter={handleMouseEnter} 
          onMouseLeave={handleMouseLeave} 
        />
        {product.variantCompareAtPrice && (
          <span className="discount-badge">
            -{Math.round(((product.variantCompareAtPrice - product.variantPrice) / product.variantCompareAtPrice) * 100)}%
          </span>
        )}
       </div>
       <div className="card-details">
        <h3 className='card-title'>{product.title}</h3>
        <div className="card-price-container">
          <span className="current-price">Rs {product.variantPrice}</span>
          {product.variantCompareAtPrice && (
            <span className="original-price">Rs {product.variantCompareAtPrice}</span>
          )}
        </div>
       </div>
      </Link>
      <div className='btn-card'>
        <button className="btn-buy-now" onClick={handleCheckout}>Buy Now</button>
        <button className="btn-add-cart" onClick={handleCheckout}>Add to Cart</button>
      </div>
    </div>
  );
}

export default Card;